(function () {
  'use strict';

  const originalFetch = window.fetch;

  // PATCH 1 — Désactiver le champ hidden vide de Shopify Subscriptions au submit
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const inputs = Array.from(form.querySelectorAll('[name="selling_plan"]'));
    if (inputs.length <= 1) return;

    const withValue = inputs.find(i => i.value !== '');
    if (withValue) {
      inputs.forEach(i => {
        if (i.value === '') i.disabled = true;
      });
    }
  }, true);

  // PATCH 2 — Intercepter fetch() et supprimer les selling_plan vides
  window.fetch = function (url, options) {
    if (
      options &&
      typeof url === 'string' &&
      url.includes('/cart/add')
    ) {
      // Cas FormData
      if (options.body instanceof FormData) {
        const plans = options.body.getAll('selling_plan');
        if (plans.length > 1) {
          options.body.delete('selling_plan');
          const valid = plans.find(v => v !== '');
          if (valid) options.body.append('selling_plan', valid);
        }
      }
      // Cas JSON body
      if (typeof options.body === 'string') {
        try {
          const data = JSON.parse(options.body);
          if (Array.isArray(data.selling_plan)) {
            const valid = data.selling_plan.find(v => v !== '');
            data.selling_plan = valid || '';
            options.body = JSON.stringify(data);
          }
        } catch (e) {}
      }
    }
    return originalFetch.apply(this, arguments);
  };

})();
